import { render, staticRenderFns } from "./kpis.vue?vue&type=template&id=0f8c884c&scoped=true&"
import script from "./kpis.vue?vue&type=script&lang=js&"
export * from "./kpis.vue?vue&type=script&lang=js&"
import style0 from "./kpis.vue?vue&type=style&index=0&id=0f8c884c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c884c",
  null
  
)

export default component.exports